import { Box } from "@mui/material";
import ViewDrawer, { DetailItem } from "../../../components/ViewDrawer";
import { useTranslation } from "../../../i18n";
import { Feeding } from "../../../interfaces/Expenses/feeding";
import styles from "../../index.module.scss";

export interface ReproductionViewProps {
  open: boolean;
  onClose: Function;
  feeding: Feeding;
}

const ReproductionView = (props: ReproductionViewProps) => {
  const { t } = useTranslation();
  const feeding: Feeding = props.feeding;
  let count = 1;

  return (
    <ViewDrawer open={props.open} onClose={props.onClose}>
      <Box className={styles.item_details}>
        <DetailItem
          index={count}
          key={count++}
          label={t("date")}
          value={feeding?.date.substring(0, 10)}
        />
        <DetailItem
          index={count}
          key={count++}
          label={t("createdBy")}
          value={feeding?.createdBy}
        />
        <DetailItem
          index={count}
          key={count++}
          label={t("createdAt")}
          value={feeding?.createdAt.substring(0, 10)}
        />
        <DetailItem
          index={count}
          key={count++}
          label={t("updatedAt")}
          value={feeding?.updatedAt.substring(0, 10)}
        />
      </Box>
    </ViewDrawer>
  );
};

export default ReproductionView;
